/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="marketPricing.module.ts" />

module Meevo.Plugins.MarketPricing {

    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;

    export class MarketPricingController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        public coColumnsSet = [
            // {header: "Price Change Scheduled", fieldName: 'PriceChangeScheduled', sortDirection: null, width: 35},
            { header: "Location Transfer Scheduled", fieldName: 'LocationTransferScheduled', sortDirection: null, width: 70 },
            { header: "Status", fieldName: 'ObjectState', sortDirection: null, width: 20 },
        ];
        public scheduleLocationContext: Meevo.Components.BaseClasses.DataMaintenanceContextBase;
        public schedulePriceContext: MarketPricingContext;
        public context: Meevo.Components.BaseClasses.DataMaintenanceContextBase;
        public isPriceManagement: boolean;

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$translate",
            "$q",
            "$timeout",
            'meevo.plugins.discounts.discountsService',
            '$http',
            'meevo.plugins.marketPricing.contextService',
            'meevo.plugins.marketPricing.scheduleLocationService',
            '$filter',
            'meevo.components.common.BusinessInfoDataService',
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: ng.IQService,
            public $timeout: ng.ITimeoutService,
            protected discountsService: Meevo.Plugins.Discounts.IDiscountsService,
            protected $http: angular.IHttpService,
            protected contextService: IContextService,
            protected scheduleLocationService: Meevo.Plugins.MarketPricing.ScheduleLocationService,
            protected $filter: ng.IFilterService,
            protected businessInfoService: BusinessInfoDataService,
        ) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.isPriceManagement = !this.identityService.inCentralOfficeMode();

            this.contextService.eventVisualState.on('changed', this.changedVisualStateManual.bind(this));
            this.contextService.setVisualState(Model.MaintenanceFormVisualState.Search);

            if (this.isPriceManagement) {
                this.visualState = Model.MaintenanceFormVisualState.Detail;
            }

        }

        searchDetailContext = {
            contextService: this.contextService,
        }

        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            let securityKey = this.isPriceManagement ? this.meevoSecurityKeys.MANAGEMENT_PRICEMANAGEMENT : this.meevoSecurityKeys.MANAGEMENT_MARKETPRICING;

            this.busyService.start();
            this.securityService.checkSection(securityKey).then(() => {
                this.busyService.stop();

                // create context
                this.context = new MarketPricingContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.busyService,
                    this.$rootScope,
                    this.$translate,
                    this.$q,
                    this,
                    this.discountsService,
                    this.contextService,
                    this.$filter,
                    this.businessInfoService,
                );
                this.context.activate(this.selectedItemId, null, this.asLocationId);

                if (this.isPriceManagement) {
                    this.context.setMode(Model.MaintenanceFormState.Readonly);
                }

                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        {
                            field: 'ObjectState',
                            label: this.$translate.instant("HEADER_STATUS"),
                            checked: false
                        },
                    ];

                // create scheduleLocationContext
                this.scheduleLocationContext = new ScheduleLocationContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$rootScope, this.$translate, this.$q, this.$http, this, this.contextService, this.scheduleLocationService);
                this.scheduleLocationContext.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };

                // create schedulePriceContext
                this.schedulePriceContext = new SchedulePriceContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$rootScope, this.$translate, this.$q, this, this.discountsService, this.contextService, this.$filter, this.businessInfoService);
                this.schedulePriceContext.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).catch(() => {
                this.busyService.stop();
            });
        }

        changedVisualStateManual(state: Model.MaintenanceFormVisualState, prevState: Model.MaintenanceFormVisualState, data: any) {
            this.visualState = state;

            switch (state) {
                case Model.MaintenanceFormVisualState.Search:
                    break;
                case Model.MaintenanceFormVisualState.Detail:
                    break;
                case Model.MaintenanceFormVisualState.CustomScheduleLocation:
                    this.showScheduleLocationContext(data);
                    break;
                case Model.MaintenanceFormVisualState.CustomSchedulePrice:
                    this.showSchedulePriceContext(data);
                    break;
            }
        }

        get isScheduleLocationContext() {
            return this.contextService.getVisualState() === Model.MaintenanceFormVisualState.CustomScheduleLocation;
        }
        public showScheduleLocationContext(data) {
            this.visualState = Model.MaintenanceFormVisualState.CustomScheduleLocation;
            this.scheduleLocationContext.activate(this.context.itemId, null, this.asLocationId);
        }

        get isSchedulePriceContext() {
            return this.contextService.getVisualState() === Model.MaintenanceFormVisualState.CustomSchedulePrice;
        }
        public showSchedulePriceContext(data) {

            let priceGroupId = data && data.priceQueueItem && data.priceQueueItem.priceGroupPriceQueueId ?
                data.priceQueueItem.priceGroupPriceQueueId : new Guid('00000000-0000-0000-0000-000000000000');

            // Set selectedItemId for don't call createContext() after back on base context on Price Management
            if (this.isPriceManagement) {
                this.selectedItemId = priceGroupId;// new Guid('00000000-0000-0000-0000-000000000000');
            }

            this.schedulePriceContext.activate(this.context.itemId, null, this.asLocationId);

            this.schedulePriceContext.setMode(Model.MaintenanceFormState.Readonly);
        }

        /**
        * Determines whether or not to showSearch in a format that is usable by the
        * UI (Can't get enum evaluation to work in UI)
        * @return {boolean}
        */
        get showSearch(): boolean {
            return this.visualState === Model.MaintenanceFormVisualState.Search && !this.isPriceManagement;
        }

        get headerName(): string {
            return this.isPriceManagement ? 'HEADER_PRICE_MANAGEMENT' : 'HEADER_MARKET_PRICING';
        }
    }

    angular.module("meevo.plugins.marketPricing")
        .controller("meevo.plugins.marketPricing.marketPricingController", MarketPricingController);
}
